const apiMeta = {
  "_meta": {
    "generateTime": "2026-09-09 09:09:55",
    "docUrl": "https://test-ws.xoyo.com/tools/doc/apis?path=jxsj/dbkh260904"
  },
  "apis": {
    "/jxsj/dbkh260904/get_config": {
      "title": "获得配置",
      "uri": "/jxsj/dbkh260904/get_config",
      "method": [
        "GET",
        "POST"
      ],
      "params": [],
      "errors": {
        "0": "系统错误",
        "1": "成功",
        "-10151": "活动未开启",
        "-10152": "活动配置错误",
        "-10153": "活动未开始",
        "-10154": "活动已结束",
        "-10402": "请先登录",
        "-10435": "不支持的通行证登录方式",
        "-20006": "账号未激活，无法进行操作"
      },
      "services": [
        "passport"
      ],
      "result": {
        "data{}": {
          "account": "脱敏账号",
          "add_up_prize": "累计档位已解锁奖励id列表",
          "follow_status": "是否已完成关注任务（1-是，0-否）",
          "had_lottery_time": "已抽奖次数",
          "is_old_account": "是否为老玩家账号",
          "lottery_time": "可抽奖次数",
          "signCount": "每日签到总数",
          "today_like_count": "今日点赞进度（0-5）",
          "today_signed": "今天是否已签到",
          "uid": "分享标识（激活账号ID）"
        }
      }
    },
    "/jxsj/dbkh260904/get_phone": {
      "title": "获得账号绑定手机号",
      "uri": "/jxsj/dbkh260904/get_phone",
      "method": [
        "GET",
        "POST"
      ],
      "params": [],
      "errors": {
        "0": "系统错误",
        "1": "成功",
        "-10151": "活动未开启",
        "-10152": "活动配置错误",
        "-10153": "活动未开始",
        "-10154": "活动已结束",
        "-10402": "请先登录",
        "-10435": "不支持的通行证登录方式"
      },
      "services": [
        "passport"
      ],
      "result": {
        "data{}": {
          "phone": "手机号"
        }
      }
    },
    "/jxsj/dbkh260904/get_phone_code": {
      "title": "获得绑定手机号验证码",
      "uri": "/jxsj/dbkh260904/get_phone_code",
      "method": [
        "GET",
        "POST"
      ],
      "params": [],
      "errors": {
        "0": "系统错误",
        "1": "成功",
        "-10101": "手机号码为空",
        "-10102": "手机号码格式错误",
        "-10151": "活动未开启",
        "-10152": "活动配置错误",
        "-10153": "活动未开始",
        "-10154": "活动已结束",
        "-10303": "短信内容为空",
        "-10305": "短信发送手机号码为空",
        "-10306": "短信发送手机号码格式错误",
        "-10308": "短信验证码发送数量达到每日上限",
        "-10309": "短信验证码发送频率太快",
        "-10316": "参数缺失",
        "-10317": "参数类型错误",
        "-10402": "请先登录",
        "-10435": "不支持的通行证登录方式",
        "-10601": "图片验证码为空",
        "-10602": "图片验证码错误",
        "-10603": "极验验证失败",
        "-10604": "图片验证码参数错误",
        "-10605": "图片验证码已过期，请重新刷新",
        "-10606": "顶象验证失败",
        "-12304": "手机号OpenId参数缺失"
      },
      "services": [
        "captcha",
        "sms",
        "passport"
      ],
      "result": {
        "data{}": []
      }
    },
    "/jxsj/dbkh260904/activate": {
      "title": "激活账号",
      "uri": "/jxsj/dbkh260904/activate",
      "method": [
        "GET",
        "POST"
      ],
      "params": {
        "id_num": {
          "desc": "身份证",
          "data": ""
        },
        "code": {
          "desc": "参数说明",
          "data": ""
        }
      },
      "errors": {
        "0": "系统错误",
        "1": "成功",
        "-10151": "活动未开启",
        "-10152": "活动配置错误",
        "-10153": "活动未开始",
        "-10154": "活动已结束",
        "-10201": "系统处理中...",
        "-10305": "短信发送手机号码为空",
        "-10306": "短信发送手机号码格式错误",
        "-10310": "短信验证码不存在",
        "-10311": "短信验证码为空",
        "-10312": "短信验证码错误",
        "-10313": "短信验证码超过有效期",
        "-10314": "短信验证码已失效",
        "-10315": "短信验证码已经被验证过，请重新获取",
        "-10402": "请先登录",
        "-10435": "不支持的通行证登录方式",
        "-20001": "该账号未绑定手机号",
        "-20002": "该账号未绑定身份证",
        "-20003": "绑定身份证验证失败，身份证号不一致",
        "-20004": "该账号已激活",
        "-20005": "该绑定身份证或绑定手机号已激活账号"
      },
      "services": [
        "sms",
        "passport"
      ],
      "result": {
        "data{}": {
          "lottery_time": "赠送的抽奖次数"
        }
      }
    },
    "/jxsj/dbkh260904/sign": {
      "title": "签到",
      "uri": "/jxsj/dbkh260904/sign",
      "method": [
        "GET",
        "POST"
      ],
      "params": [],
      "errors": {
        "0": "系统错误",
        "1": "成功",
        "-10151": "活动未开启",
        "-10152": "活动配置错误",
        "-10153": "活动未开始",
        "-10154": "活动已结束",
        "-10201": "系统处理中...",
        "-10402": "请先登录",
        "-10435": "不支持的通行证登录方式",
        "-20006": "账号未激活，无法进行操作",
        "-20007": "签到次数已满",
        "-20008": "今日已签到",
        "-20024": "抽奖次数获取已达180次上限"
      },
      "services": [
        "passport"
      ],
      "result": {
        "data{}": []
      }
    },
    "/jxsj/dbkh260904/follow": {
      "title": "关注官方账号",
      "uri": "/jxsj/dbkh260904/follow",
      "method": [
        "GET",
        "POST"
      ],
      "params": {
        "channel": {
          "desc": "关注渠道（1-微信公众号，2-剑侠福利官，3-官方抖音）",
          "data": ""
        }
      },
      "errors": {
        "0": "系统错误",
        "1": "成功",
        "-10151": "活动未开启",
        "-10152": "活动配置错误",
        "-10153": "活动未开始",
        "-10154": "活动已结束",
        "-10201": "系统处理中...",
        "-10402": "请先登录",
        "-10435": "不支持的通行证登录方式",
        "-20006": "账号未激活，无法进行操作",
        "-20010": "参数异常",
        "-20024": "抽奖次数获取已达180次上限",
        "-20029": "已完成过关注任务"
      },
      "services": [
        "passport"
      ],
      "result": {
        "data{}": {
          "lottery_time": "赠送的抽奖次数"
        }
      }
    },
    "/jxsj/dbkh260904/lottery": {
      "title": "抽奖",
      "uri": "/jxsj/dbkh260904/lottery",
      "method": [
        "GET",
        "POST"
      ],
      "params": {
        "lottery_type": {
          "desc": "抽奖类型（1-单抽，10-十连抽）",
          "data": ""
        }
      },
      "errors": {
        "0": "系统错误",
        "1": "成功",
        "-10151": "活动未开启",
        "-10152": "活动配置错误",
        "-10153": "活动未开始",
        "-10154": "活动已结束",
        "-10201": "系统处理中...",
        "-10402": "请先登录",
        "-10435": "不支持的通行证登录方式",
        "-20006": "账号未激活，无法进行操作",
        "-20009": "缺少必要参数",
        "-20010": "参数异常",
        "-20011": "大侠尚无抽奖次数，可通过每日签到、好友点赞等任务获得抽奖次数。",
        "-20012": "抽奖次数最高上限为180次哦",
        "-20023": "大侠抽奖次数不足10次，可通过每日签到、好友点赞等任务获得抽奖次数。"
      },
      "services": [
        "passport"
      ],
      "result": {
        "data{}": {
          "current_total_count": "总抽奖次数",
          "prize_data": "抽奖结果（奖品id数组）",
          "remain_time": "剩下抽奖次数"
        }
      }
    },
    "/jxsj/dbkh260904/lottery_log": {
      "title": "抽奖记录",
      "uri": "/jxsj/dbkh260904/lottery_log",
      "method": [
        "GET",
        "POST"
      ],
      "params": {
        "num": {
          "desc": "每页数量",
          "data": ""
        },
        "page": {
          "desc": "页数",
          "data": ""
        }
      },
      "errors": {
        "0": "系统错误",
        "1": "成功",
        "-10151": "活动未开启",
        "-10152": "活动配置错误",
        "-10153": "活动未开始",
        "-10154": "活动已结束",
        "-10402": "请先登录",
        "-10435": "不支持的通行证登录方式"
      },
      "services": [
        "passport"
      ],
      "result": {
        "data{}": {
          "count": "总记录数",
          "list": "抽奖记录列表"
        },
        "data{}.list[]": {
          "create_time": "创建时间",
          "id": "ID",
          "type": "抽奖类型：1-单抽，10-十连抽"
        }
      }
    },
    "/jxsj/dbkh260904/get_lottery_detail": {
      "title": "抽奖详情",
      "uri": "/jxsj/dbkh260904/get_lottery_detail",
      "method": [
        "GET",
        "POST"
      ],
      "params": {
        "id": {
          "desc": "ID",
          "data": ""
        }
      },
      "errors": {
        "0": "系统错误",
        "1": "成功",
        "-10151": "活动未开启",
        "-10152": "活动配置错误",
        "-10153": "活动未开始",
        "-10154": "活动已结束",
        "-10402": "请先登录",
        "-10435": "不支持的通行证登录方式",
        "-20009": "缺少必要参数"
      },
      "services": [
        "passport"
      ],
      "result": {
        "data{}": {
          "list": "列表"
        },
        "data{}.list[]": {
          "create_time": "创建时间",
          "prize_id": "奖励id"
        }
      }
    },
    "/jxsj/dbkh260904/prize_list": {
      "title": "奖励列表",
      "uri": "/jxsj/dbkh260904/prize_list",
      "method": [
        "GET",
        "POST"
      ],
      "params": [],
      "errors": {
        "0": "系统错误",
        "1": "成功",
        "-10151": "活动未开启",
        "-10152": "活动配置错误",
        "-10153": "活动未开始",
        "-10154": "活动已结束",
        "-10402": "请先登录",
        "-10435": "不支持的通行证登录方式"
      },
      "services": [
        "passport"
      ],
      "result": {
        "data{}": {
          "add_up_prize": "累计奖励列表",
          "lottery_prize": "抽奖奖励列表"
        },
        "data{}.add_up_prize[]": {
          "prize_id": "奖励id"
        },
        "data{}.lottery_prize[]": {
          "amount": "奖励数量",
          "prize_id": "奖励id"
        }
      }
    },
    "/jxsj/dbkh260904/time_log": {
      "title": "抽奖次数获取记录",
      "uri": "/jxsj/dbkh260904/time_log",
      "method": [
        "GET",
        "POST"
      ],
      "params": {
        "num": {
          "desc": "每页数量",
          "data": ""
        },
        "page": {
          "desc": "页数",
          "data": ""
        }
      },
      "errors": {
        "0": "系统错误",
        "1": "成功",
        "-10151": "活动未开启",
        "-10152": "活动配置错误",
        "-10153": "活动未开始",
        "-10154": "活动已结束",
        "-10402": "请先登录",
        "-10435": "不支持的通行证登录方式"
      },
      "services": [
        "passport"
      ],
      "result": {
        "data{}": {
          "count": "总记录数",
          "list": "获取记录列表"
        },
        "data{}.list[]": {
          "create_time": "创建时间",
          "num": "获取的抽奖次数",
          "type": "来源：1-激活，2-签到，3-点赞，4-关注"
        }
      }
    },
    "/jxsj/dbkh260904/get_like_info": {
      "title": "获得客态页信息",
      "uri": "/jxsj/dbkh260904/get_like_info",
      "method": [
        "GET",
        "POST"
      ],
      "params": {
        "uid": {
          "desc": "分享标识（get_config返回的uid）",
          "data": ""
        }
      },
      "errors": {
        "0": "系统错误",
        "1": "成功",
        "-10151": "活动未开启",
        "-10152": "活动配置错误",
        "-10153": "活动未开始",
        "-10154": "活动已结束",
        "-10801": "请先微信授权",
        "-20009": "缺少必要参数"
      },
      "services": [
        "wechat"
      ],
      "result": {
        "data{}": {
          "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)",
          "account": "被助力者脱敏账号",
          "is_active": "被助力者是否已激活（1-是，0-否）",
          "is_liked": "当前微信今日是否已点赞（1-是，0-否）"
        }
      }
    },
    "/jxsj/dbkh260904/do_like": {
      "title": "点赞",
      "uri": "/jxsj/dbkh260904/do_like",
      "method": [
        "GET",
        "POST"
      ],
      "params": {
        "uid": {
          "desc": "分享标识（get_config返回的uid）",
          "data": ""
        }
      },
      "errors": {
        "0": "系统错误",
        "1": "成功",
        "-10151": "活动未开启",
        "-10152": "活动配置错误",
        "-10153": "活动未开始",
        "-10154": "活动已结束",
        "-10201": "系统处理中...",
        "-10801": "请先微信授权",
        "-20009": "缺少必要参数",
        "-20025": "该好友尚未激活账号，点赞无效",
        "-20026": "您已经为好友点赞共贺过啦~",
        "-20027": "今日您已经点赞很多啦，明天再来试试吧~"
      },
      "services": [
        "wechat"
      ],
      "result": {
        "data{}": {
          "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)"
        }
      }
    }
  }
};

export default apiMeta;
